/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { MainRouteTreeModel } from '@core/models';
import { RouteCodes } from '@core/config/route-codes';

/**
 * albero delle rotte di tutta l'applicazione
 */
export const ROUTES_TREE: {
  [id: string]: MainRouteTreeModel;
} = {
  [RouteCodes.logon]: {
    path: 'logon'
  },
  [RouteCodes.activate]: {
    path: 'activate'
  },
  [RouteCodes.exit]: {
    path: 'exit'
  },
  [RouteCodes.dummy]: {
    path: 'dummy'
  },
  [RouteCodes.settings]: {
    path: 'settings'
  },
  [RouteCodes.error]: {
    path: 'error'
  },
  [RouteCodes.position]: {
    path: 'position',
    children: {
      [RouteCodes.welcome]: { path: 'welcome' },
      [RouteCodes.summary]: { path: 'summary' },
      [RouteCodes.finish]: { path: 'finish' },
      [RouteCodes.quotationCalculate]: { path: 'quotation-calculate' },
      [RouteCodes.quotation]: { path: 'quotation' },
      [RouteCodes.obligations]: { path: 'obligations' },
      [RouteCodes.resolution]: { path: 'delivery-data' },
      [RouteCodes.recognition]: { path: 'recognition' },
      [RouteCodes.consents]: { path: 'consents' },
      [RouteCodes.documentsRequest]: { path: 'documents-request' },
      [RouteCodes.adequacy]: { path: 'adequacy' },
      [RouteCodes.contractSigning]: { path: 'contract-signing' },
      [RouteCodes.customerInfo]: { path: 'customer-info' },
      [RouteCodes.financialData]: { path: 'financial-data' },
      [RouteCodes.notes]: { path: 'notes' },
      [RouteCodes.atcChoice]: { path: 'atc-choice' },
      [RouteCodes.waiting]: { path: 'waiting' },
      [RouteCodes.tfrReleaseQuote]: { path: 'tfr-release-quote' },
      [RouteCodes.ceilingReduction]: { path: 'ceiling-reduction' },
      [RouteCodes.usesReport]: { path: 'uses-report' },
      [RouteCodes.dataCollection]: { path: 'data-collection' },
      [RouteCodes.withdraw]: { path: 'withdraw' }
    }
  },
  [RouteCodes.reservedArea]: {
    path: 'reserved-area',
    children: {
      [RouteCodes.dashboard]: {
        path: 'dashboard'
      },
      [RouteCodes.customerData]: {
        path: 'customer-data'
      }
    }
  },
  [RouteCodes.anonymous]: {
    path: 'anonymous',
    children: {
      [RouteCodes.anonymousSimulation]: {
        path: 'simulation'
      },
      [RouteCodes.onboarding]: {
        path: 'onboarding'
      }
    }
  }
};

/**
 * shortcut per le rotte della position
 */
export const POSITION_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.position].children
};

/**
 * shortcut per le rotte dell'area riservata
 */
export const RESERVED_AREA_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.reservedArea].children
};

/**
 * shortcut per le rotte delle pagine anonime
 */
export const ANONYMOUS_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.anonymous].children
};
